document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.notify-form').forEach(function (form) {
    var input = form.querySelector('.field__input');
    var btn = form.querySelector('.notify-form__submit');
    var variantId = form.dataset.variantId;

    if (localStorage.getItem('bis_' + variantId)) {
      form.querySelector('.notify-form__inner').hidden = true;
      form.querySelector('.notify-form__text').hidden = true;
      form.querySelector('.notify-form__already').hidden = false;
      return;
    }

    btn.addEventListener('click', function () {
      var email = input.value.trim();
      if (!email || !input.reportValidity()) return;

      btn.setAttribute('aria-disabled', 'true');
      form.querySelector('.notify-form__error').hidden = true;

      var handle = form.dataset.productHandle || '';

      // 1) Shopify: Kunde mit notify-Tag (eigene Domain, kein Adblocker)
      var body = new FormData();
      body.append('form_type', 'customer');
      body.append('utf8', '\u2713');
      body.append('contact[email]', email);
      body.append('contact[tags]', 'notify,notify-' + handle);
      var shopifyCall = fetch('/contact', {
        method: 'POST', body: body, headers: { Accept: 'application/json' }
      });

      // 2) Klaviyo: Newsletter DOI (best effort, kann von Adblocker geblockt werden)
      var klBody = new URLSearchParams();
      klBody.append('g', 'WF4XTC');
      klBody.append('email', email);
      var klaviyoCall = fetch('https://a.klaviyo.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: klBody.toString()
      }).catch(function () {}); // Adblocker? Egal, Shopify hat die Daten.

      shopifyCall.then(function (resp) {
        if (!resp.ok && resp.status !== 422) throw new Error('signup failed');
        localStorage.setItem('bis_' + variantId, '1');
        form.classList.add('notify-form--submitted');
        form.querySelector('.notify-form__success').hidden = false;
      }).catch(function () {
        btn.removeAttribute('aria-disabled');
        form.querySelector('.notify-form__error').hidden = false;
      });
    });

    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) {
        form.dataset.variantId = e.detail.variant.id;
        variantId = e.detail.variant.id;
      }
    });
  });
});
